class StoneveilHeroMotion extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.videos = [...this.closest('.hero').querySelectorAll('video')];
    this.button = this.querySelector('button');
    if (!this.videos.length || !this.button) return;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mobile = window.matchMedia('(max-width: 749px)');
    this.userPaused = this.reducedMotion.matches || Boolean(navigator.connection?.saveData);
    this.inView = true;
    this.button.hidden = false;
    const options = { signal: this.abort.signal };
    this.button.addEventListener('click', () => {
      this.userPaused = !this.userPaused;
      this.sync();
    }, options);
    this.reducedMotion.addEventListener('change', () => {
      this.userPaused = this.reducedMotion.matches;
      this.sync();
    }, options);
    this.mobile.addEventListener('change', () => this.sync(), options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      this.sync();
    });
    this.observer.observe(this.closest('.hero'));
    this.sync();
  }

  sync() {
    const token = this.syncToken = (this.syncToken || 0) + 1;
    const mayPlay = !this.userPaused && !document.hidden && this.inView;
    for (const video of this.videos) {
      const wrapper = video.closest('.hero__media-wrapper');
      const visible = wrapper && getComputedStyle(wrapper).display !== 'none';
      if (mayPlay && visible) {
        video.muted = true;
        video.playsInline = true;
        video.play().catch(error => {
          if (!this.isConnected || token !== this.syncToken || error.name === 'AbortError') return;
          this.userPaused = true;
          this.updateButton();
          for (const item of this.videos) item.pause();
        });
      } else {
        video.pause();
      }
    }
    this.updateButton();
  }

  updateButton() {
    const paused = this.userPaused;
    this.button.dataset.state = paused ? 'paused' : 'playing';
    this.button.setAttribute('aria-label', paused ? 'Play film' : 'Pause film');
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    for (const video of this.videos ?? []) video.pause();
  }
}

if (!customElements.get('stoneveil-hero-motion')) {
  customElements.define('stoneveil-hero-motion', StoneveilHeroMotion);
}
